import DiaryListConstants from "@/store/constants/diaryListRecords";
import { putMetaDataSite } from "@/api/SiteApi";
import moment from "moment";
import MetaDataInternalData from "@/internalData/MetaData";
import { validateMetaData } from "@/services/GlobalServices";
import { resolveWorkPeriodDates } from "@/services/workPeriodService";
export default {
  name: "MetaData",
  props: [],
  data() {
    return {
      areaFields: MetaDataInternalData.areaFields,
      kendoTypeFields: MetaDataInternalData.kendoTypeFields,
      civilEngineeringKohshuTypes:
        MetaDataInternalData.civilEngineeringKohshuTypes,
      civilEngineeringOfArchitectures:
        MetaDataInternalData.civilEngineeringOfArchitectures,
      architectureKohshuTypes: MetaDataInternalData.architectureKohshuTypes,
      architectureOfArchitectures:
        MetaDataInternalData.architectureOfArchitectures,
      isArchitecture: true,
    };
  },
  computed: {
    siteSelected() {
      console.log(`SITE_SELECTED`);
      return this.$store.getters[DiaryListConstants.GETTERS.getSiteSelected];
    },
    selectedSite() {
      const sites = this.$store.getters[DiaryListConstants.GETTERS.getSites];
      return (
        this.$_.find(sites, (site) => {
          return site.id == this.siteSelected;
        }) || null
      );
    },
    workPeriod() {
      console.log(`SET_WORK_PERIOD`);
      const site = this.selectedSite;
      console.log(`==================`);
      console.log(site);
      console.log(site ? site.workPeriod : 'site is undefined');
      console.log(`==================`);
      return site && site.workPeriod ? site.workPeriod : { startDate: "", endDate: "" };
    },
    metaData() {
      return this.$store.getters[DiaryListConstants.GETTERS.getMetaDataSite];
    },
    kohshuTypeFields() {
      return this.isArchitecture
        ? this.architectureKohshuTypes
        : this.civilEngineeringKohshuTypes;
    },
    architectureFields() {
      return this.isArchitecture
        ? this.architectureOfArchitectures
        : this.civilEngineeringOfArchitectures;
    },
    contractAmountTotal() {
      console.log("CALCULATE_CHECK");
      console.log(
        `CALCULATE_WORKPERIOD.... ${JSON.stringify(this.workPeriod)}`
      );
      return Math.ceil(
        moment(this.workPeriod.endDate).diff(
          moment(this.workPeriod.startDate),
          "months",
          true
        )
      );
    },
    disableInputDiary() {
      const siteSelected =
        this.$store.getters[DiaryListConstants.GETTERS.getSiteSelected];
      return siteSelected == "" || siteSelected == null;
    },
  },
  methods: {
    get(attr) {
      const value = this.metaData ? this.$_.get(this.metaData, attr, "") : "";
      const isKendoType = attr == "totalFloorArea.value";
      if (isKendoType) {
        const kendoType = this.$_.get(this.metaData, "kendoType", "");
        this.isArchitecture = kendoType === "architecture";
        const isKendoTyeCivilEngineering = kendoType == "civilEngineering";
        return isKendoTyeCivilEngineering ? "" : value;
      }
      return value;
    },
    getArchitecture() {
      let value = this.get("architecture");
      if (value) {
        return value;
      } else {
        let kendoType = this.get("kendoType");
        if (!kendoType) {
          kendoType = "civilEngineering";
        }
        switch (kendoType) {
          case "civilEngineering":
            return "civilEngineering";
          case "architecture":
            return "RCConstruction";
          default:
            break;
        }
      }
    },
    getKohshuType() {
      let value = this.get("kohshuType");
      if (value) {
        return value;
      } else {
        let kendoType = this.get("kendoType");
        if (!kendoType) {
          kendoType = "civilEngineering";
        }
        switch (kendoType) {
          case "civilEngineering":
            return "tunnel";
          case "architecture":
            return "theOffice";
          default:
            break;
        }
      }
    },
    isKendoTypeArchitecture() {
      if (!this.get("kendoType")) {
        return false;
      }
      return this.get("kendoType") == "architecture";
    },
    getAreaDisplayValue() {
      const areaKey = this.get("area");
      if (!areaKey) {
        return "";
      }
      const areaField = this.areaFields.find(field => field.key === areaKey);
      return areaField ? areaField.value : "";
    },
    getKohshuTypeDisplayValue() {
      const kohshuTypeKey = this.getKohshuType();
      if (!kohshuTypeKey) {
        return "";
      }
      const kohshuTypeField = this.kohshuTypeFields.find(field => field.key === kohshuTypeKey);
      return kohshuTypeField ? kohshuTypeField.value : "";
    },
    getKendoTypeDisplayValue() {
      const kendoTypeValue = this.get("kendoType");
      if (kendoTypeValue) {
        const kendoTypeField = this.kendoTypeFields.find(field => field.key === kendoTypeValue);
        if (kendoTypeField) {
          return kendoTypeField.value;
        }
        return kendoTypeValue;
      }
      return this.getKohshuTypeDisplayValue();
    },
    getWorkPeriodDates() {
      // 工期は管理画面（SiteList）と一致させるため、現場マスタの計画工期
      // (plannedStartDate/plannedEndDate、無ければ実工期 startDate/endDate)から取得する。
      // site_meta は工期表示には用いない。詳細は workPeriodService.resolveWorkPeriodDates を参照。
      return resolveWorkPeriodDates(this.selectedSite);
    },
    formatDate(date) {
      if (!date) {
        return "";
      }
      try {
        return moment(date).format('YYYY/MM/DD');
      } catch (e) {
        console.error('Date formatting error:', e);
        return "";
      }
    },
    setMetaDataState(attr, value) {
      if (attr === "kendoType") {
        this.isArchitecture = value === "architecture";
      }
      this.$store.commit(DiaryListConstants.COMMIT.updateMetaDataSite, {
        attr,
        value,
      });
      setTimeout(() => {
        if (!this.errors.all().length) {
          this.updateMetaData();
        }
      }, 300);
    },
    handleValidate(attr) {
      const validateAttributes = [
        "totalFloorArea.value",
        "contractAmountWhole",
        "monthesSurveyed",
        "contractAmountSurveyed",
      ];
      if (validateAttributes.includes(attr) && this.errors.all().length) {
        this.$store.commit(DiaryListConstants.COMMIT.updateMetaDataSite, {
          attr: attr,
          value: "",
        });
      }
    },
    updateMetaData() {
      console.log("update check");
      console.log(`updateMetadata ${this.workPeriod}`);
      if (this.siteSelected && validateMetaData(this.metaData)) {
        const metaData = Object.assign({}, this.metaData, {
          workPeriod: {
            endDate: this.workPeriod.endDate,
            startDate: this.workPeriod.startDate,
          },
        });
        putMetaDataSite(this.siteSelected, metaData);
      }
    },
  },
  watch: {},
};
